const loadToggler = () => {
  if (document.querySelector('.full-width-toggler')) {
    const togglers = Array.from(document.querySelectorAll('.full-width-toggler'));

    togglers.forEach(toggler => {
      const toggles = Array.from(toggler.querySelectorAll('.full-width-toggler--toggle'));
      const toggleContents = Array.from(toggler.querySelectorAll('.full-width-toggler--description'));
      const toggleImages = Array.from(toggler.querySelectorAll('.full-width-toggler--image'));

      toggles.forEach(toggle => {
        toggle.addEventListener('click', event => {
          toggles.forEach(_toggle => _toggle.classList.remove('active'));
          toggle.classList.add('active');

          const activeContents = Array.from(toggler.querySelectorAll('.full-width-toggler--description-' + toggle.dataset.value));
          const activeImages = Array.from(toggler.querySelectorAll('.full-width-toggler--image-' + toggle.dataset.value));
          const className = event.target.dataset.toggleClass || 'hidden';
          toggleContents.forEach(toggleContent => toggleContent.classList.add(className));
          activeContents.forEach(activeContent => activeContent.classList.remove(className));
          toggleImages.forEach(toggleImage => toggleImage.classList.add(className));
          activeImages.forEach(activeImage => activeImage.classList.remove(className));
        });
      });

      const firstImage = toggleImages[0];
      const imageHeight = firstImage.offsetHeight;
      toggler.style.setProperty('--image-height', `${imageHeight}px`);

      window.addEventListener('resize', () => {
        let imageHeight = firstImage.offsetHeight;

        if (window.innerWidth >= 992) {
          imageHeight = 800;
        }

        toggler.style.setProperty('--image-height', `${imageHeight}px`);
      });
    });
  }
};

export default loadToggler;
